var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
export function LabelAction(_a) {
    var children = _a.children, label = _a.label, mobileHidden = _a.mobileHidden, pixOnly = _a.pixOnly;
    return (_jsx("div", __assign({ className: cn(mobileHidden && "hidden sm:flex", "w-full max-w-[856px] flex flex-col justify-between px-6 py-1 rounded-lg", pixOnly && "hidden") }, { children: _jsxs("div", __assign({ className: cn(mobileHidden && "hidden sm:flex", "flex justify-center sm:justify-between gap-4") }, { children: [_jsxs("div", __assign({ className: "hidden sm:flex flex-col" }, { children: [label, ":"] })), _jsx("div", __assign({ className: cn(mobileHidden && "hidden sm:flex", "flex-col") }, { children: children }))] })) })));
}
